/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Course_FormatInputs */

const en_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const es_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const fr_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const de_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const ja_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コースの形式`)
};

const zh_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`格式`)
};

const ar_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التنسيق`)
};

const id_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format`)
};

const it_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const ru_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат курса`)
};

const pt_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato`)
};

const ko_field_course_format = /** @type {(inputs: Field_Course_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`형식`)
};

/**
* | output |
* | --- |
* | "Format" |
*
* @param {Field_Course_FormatInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_course_format = /** @type {((inputs?: Field_Course_FormatInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Course_FormatInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_course_format(inputs)
	if (locale === "es") return es_field_course_format(inputs)
	if (locale === "fr") return fr_field_course_format(inputs)
	if (locale === "de") return de_field_course_format(inputs)
	if (locale === "ja") return ja_field_course_format(inputs)
	if (locale === "zh") return zh_field_course_format(inputs)
	if (locale === "ar") return ar_field_course_format(inputs)
	if (locale === "id") return id_field_course_format(inputs)
	if (locale === "it") return it_field_course_format(inputs)
	if (locale === "ru") return ru_field_course_format(inputs)
	if (locale === "pt") return pt_field_course_format(inputs)
	return ko_field_course_format(inputs)
});